export class UserSocialHandleCheckListener {
    public static bindBlur(input: HTMLInputElement, onBlur: () => void): void {
        input.addEventListener("blur", onBlur);
    }

    // Capture phase so this runs before the master-data-edit form's own
    // (bubble-phase) submit handler, letting it block the save before any
    // network request is sent.
    public static bindSubmitGuard(form: HTMLFormElement, onSubmit: (event: SubmitEvent) => void): void {
        form.addEventListener("submit", onSubmit as EventListener, true);
    }
}
